<template>
  <div>
    <v-toolbar dense flat>
      <v-app-bar-nav-icon to="/workOrder/home" small>
        <v-icon>home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>Work Order</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y v-if="$vuetify.breakpoint.xsOnly">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            {{ selectedLabel }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="selectItem('Work Order List', '/workOrder/list')">
            <v-list-item-title>Work Order List</v-list-item-title>
          </v-list-item>
          <v-list-item @click="selectItem('TechLocation', '/workOrder/techLocation/list')">
            <v-list-item-title>TechLocation</v-list-item-title>
          </v-list-item>
          <v-list-item @click="selectItem('Technician', '/workOrder/technician/list')">
            <v-list-item-title>Technician</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <div v-else>
        <v-btn text color="teal" dark to="/workOrder/list">
          Work Order List
        </v-btn>

        <v-btn text color="teal" dark to="/workOrder/techLocation/list">TechLocation</v-btn>
        <v-btn text color="teal" dark to="/workOrder/technician/list">Technician</v-btn>
      </div>
    </v-toolbar>
    <v-divider></v-divider>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "workOrder",
  data() {
    return {
      selectedLabel: "Work Order",
    };
  },
  watch: {
    '$route'(to, from) {
      this.updateLabel(to.path);
    }
  },
  created() {
    this.updateLabel(this.$route.path);
  },
  methods: {
    selectItem(label, route) {
      this.selectedLabel = label;
      this.$router.push(route);
    },
    updateLabel(path) {
      if (path.includes('/workOrder/list')) {
        this.selectedLabel = 'Work Order List';
      } else if (path.includes('/workOrder/techLocation/list')) {
        this.selectedLabel = 'TechLocation';
      } else if (path.includes('/workOrder/technician/list')) {
        this.selectedLabel = 'Technician';
      }
    }
  }
};
</script>
